import { render, staticRenderFns } from "./Products-filter-variation.vue?vue&type=template&id=2fe47c4c&"
import script from "./Products-filter-variation.vue?vue&type=script&lang=js&"
export * from "./Products-filter-variation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports